import React from 'react';
import { connect } from 'react-redux';

import AllowedMenuItem from 'components/menu/AllowedMenuItem.component';
import ForbiddenMenuItem from 'components/menu/ForbiddenMenuItem.component';
import { isEffectiveReceptionist } from 'selectors/user';

// DEPRECATED: use the child components directly instead, do not depend on isEffectiveReceptionist()
const MenuReceptionistItem = ({ onClick, icon, navLink, title, children, isReceptionist }) =>
  isReceptionist ? <ForbiddenMenuItem icon={icon} title={title} /> : <AllowedMenuItem to={navLink} onClick={onClick} icon={icon} title={title} children={children} />;

const mapStateToProps = (state) => ({
  isReceptionist: isEffectiveReceptionist(state),
});

const MenuReceptionistItemHoc = connect(mapStateToProps)(MenuReceptionistItem);

export default MenuReceptionistItemHoc;
